import { jsx as i, jsxs as y } from "react/jsx-runtime";
import * as d from "react";
import { u as K, c as k } from "./index-DjWSt7QJ.js";
import { c as w, P as C, u as E } from "./index-Bm60c36x.js";
import { c as G, R as V, I as T } from "./index-CyEsVCjm.js";
import { u as j } from "./index-DmErOS-o.js";
import { u as U } from "./index-BEuDtiQ6.js";
import { u as z } from "./index-BZPx6jYI.js";
import { P as B } from "./index-Db-zVn-7.js";
var I = "Radio", [H, S] = w(I), [W, X] = H(I), g = d.forwardRef(
  (r, n) => {
    const {
      __scopeRadio: e,
      name: a,
      checked: o = !1,
      required: t,
      disabled: s,
      value: p = "on",
      onCheck: u,
      form: f,
      ...R
    } = r, [l, m] = d.useState(null), c = E(n, (h) => m(h)), v = d.useRef(!1), b = l ? f || !!l.closest("form") : !0;
    return /* @__PURE__ */ y(W, { scope: e, checked: o, disabled: s, children: [
      /* @__PURE__ */ i(
        C.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": x(o),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: p,
          ...R,
          ref: c,
          onClick: k(r.onClick, (h) => {
            o || u == null || u(), b && (v.current = h.isPropagationStopped(), v.current || h.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ i(
        Y,
        {
          control: l,
          bubbles: !v.current,
          name: a,
          value: p,
          checked: o,
          required: t,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
g.displayName = I;
var N = "RadioIndicator", A = d.forwardRef(
  (r, n) => {
    const { __scopeRadio: e, forceMount: a, ...o } = r, t = X(N, e);
    return /* @__PURE__ */ i(B, { present: a || t.checked, children: /* @__PURE__ */ i(
      C.span,
      {
        "data-state": x(t.checked),
        "data-disabled": t.disabled ? "" : void 0,
        ...o,
        ref: n
      }
    ) });
  }
);
A.displayName = N;
var Y = (r) => {
  const { control: n, checked: e, bubbles: a = !0, ...o } = r, t = d.useRef(null), s = z(e), p = U(n);
  return d.useEffect(() => {
    const u = t.current, f = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (s !== e && l) {
      const m = new Event("click", { bubbles: a });
      l.call(u, e), u.dispatchEvent(m);
    }
  }, [s, e, a]), /* @__PURE__ */ i(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: e,
      ...o,
      tabIndex: -1,
      ref: t,
      style: {
        ...r.style,
        ...p,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function x(r) {
  return r ? "checked" : "unchecked";
}
var $ = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], P = "RadioGroup", [J, fe] = w(P, [
  G,
  S
]), D = G(), F = S(), [Q, Z] = J(P), M = d.forwardRef(
  (r, n) => {
    const {
      __scopeRadioGroup: e,
      name: a,
      defaultValue: o,
      value: t,
      required: s = !1,
      disabled: p = !1,
      orientation: u,
      dir: f,
      loop: R = !0,
      onValueChange: l,
      ...m
    } = r, c = D(e), v = j(f), [b, h] = K({
      prop: t,
      defaultProp: o,
      onChange: l
    });
    return /* @__PURE__ */ i(
      Q,
      {
        scope: e,
        name: a,
        required: s,
        disabled: p,
        value: b,
        onValueChange: h,
        children: /* @__PURE__ */ i(
          V,
          {
            asChild: !0,
            ...c,
            orientation: u,
            dir: v,
            loop: R,
            children: /* @__PURE__ */ i(
              C.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": u,
                "data-disabled": p ? "" : void 0,
                dir: v,
                ...m,
                ref: n
              }
            )
          }
        )
      }
    );
  }
);
M.displayName = P;
var O = "RadioGroupItem", L = d.forwardRef(
  (r, n) => {
    const { __scopeRadioGroup: e, disabled: a, ...o } = r, t = Z(O, e), s = t.disabled || a, p = D(e), u = F(e), f = d.useRef(null), R = E(n, f), l = t.value === o.value, m = d.useRef(!1);
    return d.useEffect(() => {
      const c = (b) => {
        $.includes(b.key) && (m.current = !0);
      }, v = () => m.current = !1;
      return document.addEventListener("keydown", c), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", c), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ i(
      T,
      {
        asChild: !0,
        ...p,
        focusable: !s,
        active: l,
        children: /* @__PURE__ */ i(
          g,
          {
            disabled: s,
            required: t.required,
            checked: l,
            ...u,
            ...o,
            name: t.name,
            ref: R,
            onCheck: () => t.onValueChange(o.value),
            onKeyDown: k((c) => {
              c.key === "Enter" && c.preventDefault();
            }),
            onFocus: k(o.onFocus, () => {
              var c;
              m.current && ((c = f.current) == null || c.click());
            })
          }
        )
      }
    );
  }
);
L.displayName = O;
var ee = "RadioGroupIndicator", q = d.forwardRef(
  (r, n) => {
    const { __scopeRadioGroup: e, ...a } = r, o = F(e);
    return /* @__PURE__ */ i(A, { ...o, ...a, ref: n });
  }
);
q.displayName = ee;
var me = M, oe = L, re = q;
const te = "_indicator_o29me_51", ae = "_label_o29me_66", _ = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: te,
  label: ae
};
function ve({ value: r, id: n, label: e, description: a }) {
  return /* @__PURE__ */ y("div", { className: _["radio-item"], children: [
    /* @__PURE__ */ i(oe, { value: r, id: n, className: _["radio-button"], "aria-label": e, children: /* @__PURE__ */ i(re, { className: _.indicator }) }),
    /* @__PURE__ */ y("label", { htmlFor: n, className: _.label, children: [
      e,
      a && /* @__PURE__ */ i("p", { children: a })
    ] })
  ] });
}
export {
  ve as I,
  me as R
};
